import * as React from 'react'
import { ChannelsService } from './channelsService'
import { GoogleTTDService } from './googleTTDService'

export const ChannelsServiceContext = React.createContext(null as any as ChannelsService)
export const GoogleTTDServiceContext = React.createContext(null as any as GoogleTTDService)
